"use client";
import { SectionCTA, SectionCTAProps } from "@/components/shared/sections/SectionCTA";
import { useAppSelector } from "@/store";
import { isWritingServiceSelector } from "@/store/global/globalSlice";

type StandardSectionCTAProps = Partial<SectionCTAProps>;

export const StandardSectionCTA = (props: StandardSectionCTAProps) => {
  const isWritingService = useAppSelector(isWritingServiceSelector);

  return (
    <SectionCTA
      heading={
        <>
          Running out of <span>time</span>?
        </>
      }
      subheading="Entrust your assignment to proficient writers and receive TOP-quality paper before the deadline is over."
      button={{
        tag: isWritingService ? "dashboardLink" : "subdomainLink",
        subdomain: isWritingService ? undefined : "writing",
        href: isWritingService ? "/order" : "/",
        type: "accent",
        children: "Hire writer",
      }}
      last
      {...props}
    />
  );
};
